module.exports = __webpack_public_path__ + "assets/img/axess@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/axess@2x.png
// module id = 47
// module chunks = 0